import { getFromBreakpoint } from '@vakantiesnl/components/src/styles/breakpoints';
import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useCustomStyles = makeStyles()((theme) => ({
	flightContainer: {
		display: 'grid',
		gap: theme.spacing.small,

		[getFromBreakpoint('lg')]: {
			gridTemplateColumns: '1fr 3fr',
			zIndex: theme.zIndex.default,
			position: 'relative',
		},
	},
	recommendedFlightTitle: {
		margin: `${theme.spacing.small} 0 ${theme.spacing.xsmall}`,

		[getFromBreakpoint('md')]: {
			margin: `0 0 ${theme.spacing.small} 0`,
		},
	},
	flights: {
		display: 'flex',
		flexDirection: 'column',
		gap: theme.spacing.small,
	},
	flightsHeader: {
		margin: `${theme.spacing.small} 0`,
	},
}));
